import { z } from 'zod'

import { DateZod, GeoPointZod } from '../common'

import { PiloteTeamTypeZod } from './pilote'

export const TeamStatusZod = z.enum([
  'IN_RETURN',
  'ASSIGNED',
  'AVAILABLE_IN_LOCATION',
  'AVAILABLE_IN_INSTITUTION',
  'AVAILABLE_IN_REGION',
  'DISSOLVED',
  'ON_BREAK',
  'AVAILABLE_AT_COORDINATES',
])

export const TeamMobileOperatorZod = z.enum(['PARTNER', 'ESCORT', 'DRIVER'])

export const TeamVolunteerZod = z
  .object({
    phoneNumber: z.string().optional(),
  })
  .optional()
  .default({})

export const TeamZod = z.object({
  piloteId: z.number(),
  active: z.boolean(),
  campaignId: z.number(),
  centralId: z.number(),
  eveningId: z.number().optional(),
  regionId: z.string(),
  version: z.number().optional().default(0),
  volunteersPhoneNumbers: z.string().array().optional().default([]),
  number: z.number().nullable(),
  status: TeamStatusZod,
  type: PiloteTeamTypeZod,
  driver: TeamVolunteerZod,
  escort: TeamVolunteerZod,
  partner: TeamVolunteerZod,
  vehicle: z.object({
    electric: z.boolean(),
    manual: z.boolean(),
  }),
  usingMobileApplication: z.boolean().optional().default(false),
  mobileOperator: TeamMobileOperatorZod.optional().default('PARTNER'),
  vip: z.boolean().optional().default(false),
  base: z.string().optional(),
  startingLocation: z.string().optional(),
  startingLocationPiloteId: z.number().optional(),
  transportRequest: z
    .object({
      id: z.string(),
      status: z.enum(['allocated', 'assigned', 'on_board']),
    })
    .optional(),
  availableForAutomation: z.boolean().optional(),
  availableSince: DateZod.optional(),
  availableGeolocation: GeoPointZod.optional(),
  availableGeolocationSince: DateZod.optional(),
  availableAtPlace: z
    .object({
      type: z.enum(['location', 'institution', 'region']),
      piloteId: z.number(),
    })
    .optional(),
  completedTransportRequestCount: z.number().optional().default(0),
  donationCount: z.number().optional(),
  donationAmount: z.number().optional(),
  electronicDonationCount: z.number().optional(),
  electronicDonationAmount: z.number().optional(),
  vehicleMileageStart: z.number().optional(),
  vehicleMileageEnd: z.number().optional(),
  headquarterPhoneNumber: z.string().optional().default(''),
  showLastTransportRequestCancelledAlert: z.boolean().optional().default(false),
  showLastTransportRequestCancelledAlertTimestamp: DateZod.optional(),
  participationEnded: z.boolean().optional(),
  dashboardPendingRequest: z
    .object({
      type: z.string(),
      timestamp: DateZod,
      payload: z.record(z.string(), z.unknown()).optional(),
    })
    .optional(),
  messagingStatus: z
    .object({
      teamMessageCount: z.number().optional().default(0),
      hasUnreadTeamMessages: z.boolean().optional().default(false),
      hasUnreadAdminMessages: z.boolean().optional().default(false),
    })
    .optional()
    .default({ teamMessageCount: 0, hasUnreadTeamMessages: false, hasUnreadAdminMessages: false }),

  pendingEvent: z
    .union([
      z.object({
        type: z.string(),
        timestamp: DateZod,
      }),
      z.string(),
    ])
    .optional(),
})
